import { faBrain, faChartLine, faLeaf, faSmile, faUsers, faUtensils, faWind } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { BannerSection, ContactForm, FeatureTilesSection, Header, ListSection, TransformSection } from "../../../components/template";

const Thrive = () => {

const includedItems = [
  { icon: faBrain, text: "Deep work strategies for sharper focus and efficiency" },
  { icon: faSmile, text: "Positive psychology tools to increase motivation and job satisfaction" },
  { icon: faChartLine, text: "Growth mindset training to enhance focus and resilience" },
  { icon: faLeaf, text: "Yogic techniques for boosting energy and stamina" },
  { icon: faWind, text: "Stress-reducing mindfulness and breathwork practices" },
  { icon: faUtensils, text: "Interactive nutrition session for sustained well-being" },
  { icon: faUsers, text: "Engaging activities to strengthen team connection and morale" },
];
  const benefits = [
    {
      subhead: "Short-Term Fix",
      content: "Motivation peaks during the event but fades quickly.",
    },
    {
      subhead: "Surface-Level Engagement",
      content: "Fun activities but no deep emotional or mental reset.",
    },
    {
      subhead: "One-Size-Fits-All",
      content: "Fails to address individual well-being and team dynamics.",
    },
    {
      subhead: "No Integration into Daily Work Life",
      content: "A temporary break, not a lasting transformation.",
    },
  ];
  
  const icon = "🚫"; // Icon for each benefit point
  const featp="Your team deserves more than games and quick escape—they need a real, lasting system to recharge, refocus, and thrive."
const transformImage="/assets/thrive/t6.jpg";
const transformHeading="THRIVE’s Game-Changing Benefits ";
const transformParagraph=<><strong>Outcome-</strong> Aligned, energized, and unstoppable teams.</>;
const transformPoints = [
  <>
    <b>Laser Focus–</b>Eliminate distractions and sharpen attention.</>,
  <>
    <b>Resilience & Stress Mastery –</b>Thrive under pressure and bounce back stronger. </>,
  <>
    <b> Sustained Motivation –</b>Fuel long-term engagement and job satisfaction.</>,
  <>
    <b>Physical Vitality –</b>Boost stamina and prevent fatigue with office-friendly yoga
  </>,
  <>
  <b>Stronger Team Synergy –</b>Build trust and collaboration through mindful connection</>

];
const ticons = ["🔥", "⚡", "💪", "🌟", "🤝"];
const bannerp="💡 “Happy, healthy teams don’t just work better—they thrive.”";
const heading = <span className="inline-block pl-6 md:pl-16">Who is THRIVE For?</span>;
  const features = [
    { icon: "⚡", text: "Teams facing stress, fatigue, and low motivation" }, // Lightning for energy boost
  { icon: "🎯", text: "Leaders & managers seeking focus and clarity" }, // Target for focus
  { icon: "📈", text: "Companies aiming for higher productivity and engagement" }, // Growth chart for productivity
  { icon: "💖", text: "Organizations investing in long-term employee well-being" } // Heart for well-being
];
const mediaItems = [
{ type: "image", src: "/assets/thrive/t1.jpg" },
  { type: "image", src: "/assets/thrive/t2.jpg" },
{ type: "image", src: "/assets/thrive/t3.jpg" },
{ type: "image", src: "/assets/thrive/t4.jpg" },
  { type: "image", src: "/assets/thrive/t5.jpg" },
  { type: "image", src: "/assets/thrive/t7.jpg" },
  { type: "image", src: "/assets/thrive/t8.jpg" },
  { type: "image", src: "/assets/thrive/t9.jpg" },

]

const para="Ready to break the cycle of stress, fatigue, low performance, and disengagement? Write to us now –";
const icons = ["✨", "🧘‍♂️", "🏆"]; 
  return (
    <>
        <div className="w-full text-center p-8 md:p-10 bg-light">
          <h1 className="text-2xl md:text-4xl  font-bold text-[#8B2218] leading-tight">
          THRIVE   </h1>
          <h2 className="text-lg md:text-2xl  text-[#578d48] font-bold mt-4 md:mt-14">
          Unlock your team’s true potential       </h2></div>

        <Header
      

       description={[
        " Tailored to your organization’s needs & pain points",
" Built for lasting health, motivation, & productivity"
      ]}
       
    
      date={[
        <>
          <p className="text-gray-700  z-20 "key="1">
            What if your team didn’t just <strong>survive</strong> but{" "}
            <strong>thrived</strong>—every single day?
          </p>
          <br></br>
          <p className="text-gray-700 font-light z-20 " key="2">
          Burnout, stress, and distractions are draining workplace productivity and morale. And conventional employee engagement activities fail to make any meaningful difference. <strong className="font-bold "> THRIVE</strong > is a science-backed wellness program designed to elevate energy, focus, and collaboration—while reducing stress and fatigue.</p>
        </>,
      ]}
      mediaItems={mediaItems} 
      showVideo={false}
      icons={icons}
   
    />
    
    <TransformSection  imageSrc={transformImage} altText="Thrive Benefits" heading={transformHeading} paragraph={transformParagraph} points={transformPoints} ticons={ticons} />
    <ListSection  items={includedItems}/>

      {/* Feature Tiles Section */}
      <FeatureTilesSection
        heading2="Why Traditional Corporate Wellness Falls Short"
        benefits={benefits}
        icon={icon}
        featp={featp}
      />
                       <BannerSection heading={heading}  features={features} bannerp={bannerp} />
           <ContactForm para={para}/>
           </>
  );
};

export default Thrive;

